import React from 'react'
import MenuItem, { menuItemClasses } from '@mui/material/MenuItem'
import styled from 'particles/themes/styled'

const StyledMenuItem = styled(MenuItem)`
    &.${menuItemClasses.root} {
        height: 1px;
        min-height: 1px;
        width: 100%;
        padding: 0;
        margin: 4px 0;
        background: ${({ theme }) => theme.colors.divider.primary};
        &.${menuItemClasses.disabled} {
            opacity: 1;
        }
    }
`

const MenuItemDivider: React.FC = () => {
    return <StyledMenuItem disabled />
}

export default MenuItemDivider
